module.exports = __webpack_public_path__ + "be.no1.a953ed70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/be.no1.jpg
// module id = 9icZ
// module chunks = 0